module.exports = __webpack_public_path__ + "static/media/cocogeladinho-partitura.a25f4fe6.png";